import BaseResponse from "@core/interfaces/network/BaseResponse";
import { useQuery } from "@tanstack/react-query";
import UserRepo from "../repositories/UserRepo";
import { User } from "@interfaces/user.interface";
import LawRepo from "../repositories/LawRepo";

export const useAiAnswer = (query: string,  enabled: boolean = true) =>
  useQuery({
    queryKey: ["ai-answer", query],
    queryFn: async (): Promise<BaseResponse<string>> => {
      const { response, error } = await LawRepo.aiAnswer(query);
      if (error || !response) {
        throw error || new Error(`Cannot fetch ai answer`);
      }
      return response;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });


export const useAiSearch = (query: string, type: 0 | 1 | 2, enabled: boolean = true) =>
  useQuery({
    queryKey: ["ai-search", query, type],
    queryFn: async (): Promise<BaseResponse<string>> => {
      const { response, error } = await LawRepo.aiSearch(query, type);
      if (error || !response) {
        throw error || new Error(`Cannot fetch ai search`);
      }
      return response;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
